import { BuildingControlProject, mapBuildingControlProject } from "./BuildingControlQuotationType";

// ---------------------------------------- Building control permission

/* Building control permission list */
export interface BuildingControlPermission {
    id: number;
    project_id: number;
    project_detail: BuildingControlProject | null;
    employee_list: BuildingControlPermissionEmployee[];
}

export const mapBuildingControlPermission = (data: any): BuildingControlPermission => {
    if (!data) {
        throw new Error("Invalid building control permission type");
    }

    const buildingControlPermission: BuildingControlPermission = {
        id: data.id,
        project_id: data.project_id,
        project_detail: data.project_detail ? mapBuildingControlProject(data.project_detail) : null,
        employee_list: Array.isArray(data.employee_list) ? mapBuildingControlPermissionEmployees(data.employee_list) : [],
    };

    return buildingControlPermission;
};

export const mapBuildingControlPermissions = (data: any[]): BuildingControlPermission[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid building control permission data");
    }

    return data.map(mapBuildingControlPermission);
};
/*  */

/* Building control permission employee list */
export interface BuildingControlPermissionEmployee {
    id: number;
    contact_id: number;
    first_name: string;
    last_name: string;
    email: string;
    mobile: string | null;
    landline: string | null;
    address: string | null;
    city: string | null;
    post_code: string | null;
    profile_image: string | null;
    contact_subtype: string;
    bcp_employee_id: number;
    added_service_list: BuildingControlPermissionEmployeeService[];
}

export const mapBuildingControlPermissionEmployee = (data: any): BuildingControlPermissionEmployee => {
    if (!data) {
        throw new Error("Invalid building control permission employee type");
    }

    const buildingControlPermissionEmployee: BuildingControlPermissionEmployee = {
        id: data.id,
        contact_id: data.contact_id,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        mobile: data.mobile ?? null,
        landline: data.landline ?? null,
        address: data.address ?? null,
        city: data.city ?? null,
        post_code: data.post_code ?? null,
        profile_image: data.profile_image ?? null,
        contact_subtype: data.contact_subtype,
        bcp_employee_id: data.bcp_employee_id ?? null,
        added_service_list: Array.isArray(data.added_service_list) ? mapBuildingControlPermissionEmployeeServices(data.added_service_list) : [],
    };

    return buildingControlPermissionEmployee;
};

export const mapBuildingControlPermissionEmployees = (data: any[]): BuildingControlPermissionEmployee[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid building control permission employee data");
    }

    return data.map(mapBuildingControlPermissionEmployee);
};
/*  */


/* Building control permission employee service list */
export interface BuildingControlPermissionEmployeeService {
    id: number;
    feature_name: string;
    category: 'Others' | 'Building Control' | null;
    tab: string;
    key_name: string;
    display_name: string;
    status: 1 | 0;
    now_available: 1 | 0;
    can_view: 1 | 0;
    can_edit: 1 | 0;
}

export const mapBuildingControlPermissionEmployeeService = (data: any): BuildingControlPermissionEmployeeService => {
    if (!data) {
        throw new Error("Invalid building control permission employee service type");
    }

    const buildingControlPermissionEmployeeService: BuildingControlPermissionEmployeeService = {
        id: data.id,
        feature_name: data.feature_name,
        category: data.category,
        tab: data.tab,
        key_name: data.key_name,
        display_name: data.display_name,
        status: data.status,
        now_available: data.now_available,
        can_view: data.can_view,
        can_edit: data.can_edit,
    };

    return buildingControlPermissionEmployeeService;
};

export const mapBuildingControlPermissionEmployeeServices = (data: any[]): BuildingControlPermissionEmployeeService[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid building control permission employee service data");
    }

    return data.map(mapBuildingControlPermissionEmployeeService);
};
/*  */

/* Permission Payload */
export interface BuildingControlPermissionPayload {
    add_default_id: number;
    can_edit: 1 | 0;
}